// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/customer_contract_csv_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { CustomerContractCsvService } from "./customer_contract_csv_service_pb";

/**
 * ImportCustomerContracts は顧客契約 CSV を検証・反映する (dry_run=true でプレビュー)。
 *
 * @generated from rpc bffuser.v1.CustomerContractCsvService.ImportCustomerContracts
 */
export const importCustomerContracts = CustomerContractCsvService.method.importCustomerContracts;

/**
 * ExportCustomerContracts は削除されていない全地点 (見込み・失注を含む) を 1 地点 1 行で返す。
 *
 * @generated from rpc bffuser.v1.CustomerContractCsvService.ExportCustomerContracts
 */
export const exportCustomerContracts = CustomerContractCsvService.method.exportCustomerContracts;
